import { QueryKey } from "@tanstack/react-query";
import { queryClient } from "../helpers/queryClient";


interface ExecuteCacheInterface<T> {
  isForceDelete?: boolean;
  cacheKey: QueryKey;
  queryFn: () => Promise<T>;
}

export default class CacheReq {

  async ExecuteCacheRequest<T>({
    isForceDelete = false,
    cacheKey,
    queryFn
  }: ExecuteCacheInterface<T>){
    const cachedDataOld = queryClient.getQueryData<T>(cacheKey);
    if(isForceDelete && cachedDataOld){
      queryClient.removeQueries({ queryKey: cacheKey, exact: true })
    }
    //check if is cached
    const cachedData = queryClient.getQueryData<T>(cacheKey);
    if(cachedData){
      return cachedData;
    }
    const data = await queryClient.fetchQuery({
      queryKey: cacheKey,
      queryFn: () => queryFn(),
    });
    return data;
  }
}
